import type * as Types from '@formic/fusion-graphql/schema';

import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type HomeScreenThemeByIdQueryVariables = Types.Exact<{
  themeId: Types.Scalars['Int'];
}>;


export type HomeScreenThemeByIdQuery = { theme: { id: number, name: string, description: string, data: string } };

export type HomeScreenThemesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HomeScreenThemesQuery = { themes: Array<{ id: number, name: string, description: string, data: string }> };


export const HomeScreenThemeByIdDocument = /*#__PURE__*/ gql`
    query homeScreenThemeById($themeId: Int!) {
  theme(themeId: $themeId) {
    id
    name
    description
    data
  }
}
    `;

export function useHomeScreenThemeByIdQuery(options: Omit<Urql.UseQueryArgs<HomeScreenThemeByIdQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HomeScreenThemeByIdQuery>({ query: HomeScreenThemeByIdDocument, ...options });
};
export const HomeScreenThemesDocument = /*#__PURE__*/ gql`
    query homeScreenThemes {
  themes {
    id
    name
    description
    data
  }
}
    `;

export function useHomeScreenThemesQuery(options: Omit<Urql.UseQueryArgs<HomeScreenThemesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HomeScreenThemesQuery>({ query: HomeScreenThemesDocument, ...options });
};